import { ShoppingCart, User, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { UserMenuDrawer } from './UserMenuDrawer';
import { useCart } from '@/contexts/CartContext';
import { useAuth } from '@/contexts/AuthContext';
import { useState } from 'react';
import { LoginDialog } from './LoginDialog';
import { CartDrawer } from './CartDrawer';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

export const AccountHeader = () => {
  const { cart, setIsCartOpen } = useCart();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showUserMenuDrawer, setShowUserMenuDrawer] = useState(false);

  const cartItemsCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleCartClick = () => {
    setIsCartOpen(true);
  };

  const handleUserIconClick = () => {
    if (!isAuthenticated) {
      setShowLoginDialog(true);
    } else {
      setShowUserMenuDrawer(true);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  // Determine if we should show back button (not on home page)
  const showBackButton = location.pathname !== '/';

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4">
          <div className="flex h-16 items-center justify-between">
            {/* Left Section - Logo and Back Button */}
            <div className="flex items-center gap-4">
              {showBackButton && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={handleBackToHome}
                  className="h-9 w-9"
                  aria-label="Back to home"
                >
                  <ArrowLeft className="h-5 w-5" />
                </Button>
              )}
              <Link to="/" className="flex items-center">
                <img 
                  src="/logoFinal.svg" 
                  alt="Indispare Logo" 
                  className="h-8 md:h-10 w-auto"
                />
              </Link>
            </div>

            {/* Right Section - Cart and User Menu */}
            <div className="flex items-center gap-2">
              {/* Cart Icon */}
              <Button
                variant="ghost"
                size="icon"
                onClick={handleCartClick}
                className="relative h-9 w-9"
                aria-label="Shopping cart"
              >
                <ShoppingCart className="h-5 w-5" />
                {cartItemsCount > 0 && (
                  <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                    {cartItemsCount > 99 ? '99+' : cartItemsCount}
                  </span>
                )}
              </Button>

              {/* User Menu */}
              <Button
                variant="ghost"
                size="icon"
                onClick={handleUserIconClick}
                className="h-9 w-9"
                aria-label="User menu"
              >
                <User className="h-5 w-5" />
              </Button>
            </div>
          </div>
        </div>
      </header>
      <LoginDialog open={showLoginDialog} onOpenChange={setShowLoginDialog} />
      <CartDrawer>
        <div />
      </CartDrawer>
      <UserMenuDrawer open={showUserMenuDrawer} onOpenChange={setShowUserMenuDrawer} />
    </>
  );
};

